
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hinnasto",
      function () {
        return require("private-next-pages/hinnasto.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hinnasto"])
      });
    }
  